export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'workflow_manage',
  'conversation_resolve',
  'conversation_confidential_manage',
  'personalization_manage',
  'personalization_branding_manage',
  'personalization_sidebar_manage',
  'personalization_theme_manage',
  'assignment_policy_manage',
  'audit_log_view',
  'support_ticket_manage',
  'release_announcement_manage',
  'operations_dashboard_view',
  'follow_up_manage',
  'account_manage',
  'agent_manage',
  'team_manage',
  'inbox_manage',
  'label_manage',
  'custom_attribute_manage',
  'automation_manage',
  'agent_bot_manage',
  'macro_manage',
  'canned_response_manage',
  'integration_manage',
  'custom_role_manage',
  'sla_manage',
  'security_manage',
  'billing_manage',
  'campaign_manage',
  'trash_manage',
  'automated_email_manage',
];

export const CUSTOM_ROLE_PERMISSION_GROUPS = [
  {
    key: 'conversations',
    permissions: [
      'conversation_manage',
      'conversation_unassigned_manage',
      'conversation_participating_manage',
      'conversation_resolve',
      'conversation_confidential_manage',
    ],
  },
  {
    key: 'data',
    permissions: [
      'contact_manage',
      'report_manage',
      'knowledge_base_manage',
      'workflow_manage',
    ],
  },
  {
    key: 'administration',
    permissions: [
      'assignment_policy_manage',
      'audit_log_view',
      'support_ticket_manage',
      'release_announcement_manage',
      'operations_dashboard_view',
      'follow_up_manage',
    ],
  },
  {
    key: 'personalization',
    permissions: [
      'personalization_branding_manage',
      'personalization_sidebar_manage',
      'personalization_theme_manage',
    ],
  },
  {
    key: 'configuration',
    permissions: [
      'account_manage',
      'agent_manage',
      'team_manage',
      'inbox_manage',
      'label_manage',
      'custom_attribute_manage',
      'automation_manage',
      'agent_bot_manage',
      'macro_manage',
      'canned_response_manage',
      'integration_manage',
      'custom_role_manage',
      'sla_manage',
      'security_manage',
      'billing_manage',
      'campaign_manage',
      'trash_manage',
      'automated_email_manage',
    ],
  },
];

export const expandLegacyPermissions = permissions => {
  if (!permissions.includes('personalization_manage')) return [...permissions];

  return [
    ...permissions.filter(item => item !== 'personalization_manage'),
    'personalization_branding_manage',
    'personalization_sidebar_manage',
    'personalization_theme_manage',
  ];
};

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
